import { render } from "./SendTaskPicker.vue?vue&type=template&id=b6c60500&scoped=true&ts=true"
import script from "./SendTaskPicker.vue?vue&type=script&lang=ts"
export * from "./SendTaskPicker.vue?vue&type=script&lang=ts"

import "./SendTaskPicker.vue?vue&type=style&index=0&id=b6c60500&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6c60500"]])

export default __exports__